// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text_dynamic_table {
  color: #6b6b6b;
  text-align: center;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  text-transform: capitalize;
}

.img_width_listing {
  border-radius: 50px;
  height: 80px;
  width: 80px;
}

.background_color_booking_list {
  background-color: white;
  padding: 1% 2%;
  border: 2px solid rgb(239, 240, 241);
  border-radius: 8px;
  position: relative;
  cursor: pointer;
  margin-top: 1%;
}

.london_text_sub1 {
  position: absolute;
  bottom: 20px;
  right: 15px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: rgb(108, 108, 108);
}

.color_microlaser {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: rgb(68, 68, 68);
}

.london_text {
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: rgb(170, 170, 170);
}

.london_text_sub {
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgb(108, 108, 108);
}

.text_dynamic_table1 {
  color: #6b6b6b;
  text-align: center;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.text_dynamic_table_text {
  color: #a4a4a4;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28.8px; /* 180% */
}

.text_dynamic_table_text1 {
  color: #a4a4a4;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px !important;
}

.cursor_point {
  cursor: pointer;
}

.padding_manage {
  padding-top: 8px;
  padding-bottom: 8px;
}

.badge_style_wh {
  color: white !important;
}

.margin_adjust_new {
  margin-top: 3px;
  margin-bottom: -0.2px;
  text-align: center;
}

.margin_top_oftable {
  margin-top: 0.5px;
}

.border_top_orange {
  border-top: 4px solid #f5bf00;
  border-top-left-radius: 5px !important;
}

.dropdown-toggle::after {
  display: none !important;
}

.color_icon_dropdown {
  text-decoration: none;
  color: gray;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Dashboard/MainComponent/new-customer-list/components/Dtable.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;AACF;;AACA;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AAEF;;AAAA;EACI,uBAAA;EACA,cAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAGJ;;AADA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAIJ;;AAFA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AAKF;;AAHA;EACE,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AAMF;;AAJA;EACE,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;AAOF;;AALA;EACE,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAQF;;AALA;EACE,cAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,SAAA;AAQF;;AANA;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;AASF;;AAPA;EACE,eAAA;AAUF;;AAPA;EACE,gBAAA;EACA,mBAAA;AAUF;;AAPA;EACE,uBAAA;AAUF;;AAPA;EACE,eAAA;EACA,qBAAA;EACA,kBAAA;AAUF;;AAPA;EACE,iBAAA;AAUF;;AAPA;EACE,6BAAA;EACA,sCAAA;AAUF;;AAPA;EACE,wBAAA;AAUF;;AAPA;EACE,qBAAA;EACA,WAAA;AAUF","sourcesContent":[".text_dynamic_table {\n  color: #6b6b6b;\n  text-align: center;\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 25px;\n  text-transform: capitalize;\n}\n.img_width_listing {\n  border-radius: 50px;\n  height: 80px;\n  width: 80px;\n}\n.background_color_booking_list{\n    background-color: white;\n    padding: 1% 2%;\n    border: 2px solid rgb(239, 240, 241);\n    border-radius: 8px;\n    position: relative;\n    cursor: pointer;\n    margin-top: 1%;\n}\n.london_text_sub1 {\n    position: absolute;\n    bottom: 20px;\n    right: 15px;\n    font-family: Roboto;\n    font-size: 12px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    letter-spacing: normal;\n    color: rgb(108, 108, 108);\n}\n.color_microlaser {\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: 900;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: rgb(68, 68, 68);\n}\n.london_text {\n  font-family: Roboto;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: rgb(170, 170, 170);\n}\n.london_text_sub {\n  font-family: Roboto;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: rgb(108, 108, 108);\n}\n.text_dynamic_table1 {\n  color: #6b6b6b;\n  text-align: center;\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.text_dynamic_table_text {\n  color: #a4a4a4;\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28.8px; /* 180% */\n}\n.text_dynamic_table_text1 {\n  color: #a4a4a4;\n  font-family: Poppins;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 40px !important;\n}\n.cursor_point {\n  cursor: pointer;\n}\n\n.padding_manage {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.badge_style_wh {\n  color: white !important;\n}\n\n.margin_adjust_new {\n  margin-top: 3px;\n  margin-bottom: -0.2px;\n  text-align: center;\n}\n\n.margin_top_oftable {\n  margin-top: 0.5px;\n}\n\n.border_top_orange {\n  border-top: 4px solid #f5bf00;\n  border-top-left-radius: 5px !important;\n}\n\n.dropdown-toggle::after {\n  display: none !important;\n}\n\n.color_icon_dropdown {\n  text-decoration: none;\n  color: gray;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
